module.exports = {
	title1:'订单',
	typeholder:'请选择订单类型',
	stateholder:'请选择订单状态',
	code:'订单编号',
	type:'订单类型',
	time:'创建时间',
	state:'订单状态',
	title:'关闭订单',
	detailtitle:'订单详情'
}


// WEBPACK FOOTER //
// ./src/i18n/locales/en-us/modules/order.js